import { useState, useContext } from "react";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { IoMdEye } from "react-icons/io";
//Import from project
import "../../Style/actionstyle.scss";
import { useDeleteImageServer } from "../CropImage/DeleteImageServer";
import TeacherForm from "./TeacherForm";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { AuthContext } from "../../Context/AuthContext";
import { DELETE_USER } from "../../Schema/User";
import DialogDelete from "../../Utils/DialogDelete";
import { useMutation } from "@apollo/client";
export default function TeacherAction({ editData, setRefetch }) {
  // Change Language
  const { t, setAlert } = useContext(AuthContext);

  let navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  const mutationDelete = useDeleteImageServer();

  const [deleteUser] = useMutation(DELETE_USER, {
    onCompleted: ({ deleteUser }) => {
      // console.log("deleteUser :", deleteUser);
      setLoading(false);
      if (deleteUser?.isSuccess === true) {
        setAlert(true, "success", deleteUser?.message);
        handleCloseDel();
        setRefetch();
        if (editData?.profile) {
          let splitSrc = editData?.profile?.split(":")[4];
          mutationDelete.mutate({
            storage: "sr_music_academy",
            folder: "sr_music_images",
            file: splitSrc.split("/")[0],
          });
        }
      } else {
        setAlert(true, "error", deleteUser?.message);
      }
    },
    onError: (error) => {
      console.log("Error", error?.message); 
    },
  });

  const handleDelete = () => {
    deleteUser({
      variables: {
        id: editData?._id,
      },
    });
  };

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        <Tooltip title={t("view")} placement="top">
          <IconButton
            onClick={() =>
              navigate(`/teacher/teacher-detail?teacherId=${editData?._id}`)
            }
          >
            <Box className="view-container">
              <IoMdEye className="view-icon" />
            </Box>
          </IconButton>
        </Tooltip>

        <Tooltip title={t("update")} placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <MdModeEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>

        <Tooltip title={t("delete")} placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      <TeacherForm
        open={openEdit}
        dialogTitle={"Update"}
        editData={editData}
        setRefetch={setRefetch}
        handleClose={handleCloseEdit}
      />

      <DialogDelete
        open={openDel}
        handleClose={handleCloseDel}
        loading={loading}
        deleteTitle={t("modal_title_delete_teacher")}
        handleDelete={handleDelete}
        editData={editData}
      />
    </div>
  );
}
